import axios from 'axios';
import config from "../../config/config";
import createDOMPurify from "dompurify";

let cancelToken;
const DOMPurify = createDOMPurify(window);
// ----------------------- TO RELOAD PAGE ON URL CHANGE STARTS HERE --------------------
window.onhashchange=function(){
    window.location = window.location.href;
}
// ----------------------- TO RELOAD PAGE ON URL CHANGE ENDS HERE --------------------


// ------------------------ CALLING SEARCH THRU URL ON PAGE LOAD STARTS HERE ------------------
export const performSearch=()=>{
    let urlHash=window.location.hash.replace("#","").split("&");
    let srchquery=urlHash[0];
    let pagenum=urlHash[1];
    let filter=urlHash[2];
    if(srchquery==="") return;
    srchquery=srchquery.replace("s=","");
    pagenum=pagenum===undefined?"1":pagenum.replace("page=","");
    filter=filter===undefined?"All":filter.replace("filter=","");
    swiftypeCall(srchquery,pagenum,filter);
 }
// ------------------------ CALLING SEARCH THRU URL ON PAGE LOAD ENDS HERE ------------------


// ------------------------ SENDING TO SEARCH PAGE WITH QUERY STARTS HERE ------------------
export const goToSearchPage=()=>{
    let srchquery=document.querySelector('#inputSearch').value;
    if(srchquery==="") return;
    let pagenum=1;
    let filter="All";
    let urlHash=`#s=${srchquery}&page=${pagenum}&filter=${filter}`;
    window.location.replace(window.location.origin+"/search"+urlHash);
}
// ------------------------ SENDING TO SEARCH PAGE WITH QUERY ENDS HERE ------------------


// -------------------- SEARCH BUTTON CLICKED STARTS HERE ----------------
export const searchText=(srchquery)=>{
    let pagenum=1;
    let filter="All";
    if(srchquery==="") return;
    window.location.hash=`#s=${srchquery}&page=${pagenum}&filter=${filter}`;
}
// -------------------- SEARCH BUTTON CLICKED ENDS HERE ----------------


// -------------------- GO TO PREVIOUS PAGE STARTS HERE ----------------
export const prevPageResult=()=>{
    let urlHash=window.location.hash.replace("#","").split("&");
    let srchquery=urlHash[0];
    let pagenum=urlHash[1];
    let filter=urlHash[2];
    srchquery=srchquery===""?"wiley":srchquery.replace("s=","");
    pagenum=pagenum===undefined?"1":pagenum.replace("page=","");
    filter=filter===undefined?"All":filter.replace("filter=","");
    window.location.hash=`#s=${srchquery}&page=${Number(pagenum)-1}&filter=${filter}`;
}
// -------------------- GO TO PREVIOUS PAGE ENDS HERE ----------------



// -------------------- GO TO NEXT PAGE STARTS HERE ----------------
export const nextPageResult=()=>{
    let urlHash=window.location.hash.replace("#","").split("&");
    let srchquery=urlHash[0];
    let pagenum=urlHash[1];
    let filter=urlHash[2];
    srchquery=srchquery===""?"wiley":srchquery.replace("s=","");
    pagenum=pagenum===undefined?"1":pagenum.replace("page=","");
    filter=filter===undefined?"All":filter.replace("filter=","");
    window.location.hash=`#s=${srchquery}&page=${Number(pagenum)+1}&filter=${filter}`;
}
// -------------------- GO TO NEXT PAGE ENDS HERE ----------------



// -------------------- CHANGE FILER OPTION STARTS HERE ----------------
export const changeFilerOption=()=>{
    let urlHash=window.location.hash.replace("#","").split("&");
    let srchquery=urlHash[0];
    let pagenum=1;
    let filter=document.querySelector("#selectSearchFilter").value;
    srchquery=srchquery==""?"wiley":srchquery.replace("s=","");
    window.location.hash=`#s=${srchquery}&page=${pagenum}&filter=${filter}`;
}
// -------------------- CHANGE FILER OPTION ENDS HERE ----------------



// ------------------------------- SWIFTYPE API CALLS STARTS HERE -----------------------
const swiftypeCall=(srchquery="wiley",pagenum="1",filter="All")=>{
    srchquery=decodeURI(srchquery);
    srchquery=DOMPurify.sanitize(srchquery);
    pagenum=DOMPurify.sanitize(pagenum);
    filter=DOMPurify.sanitize(filter);
    document.querySelector(".srch-tab-lists").innerHTML="";
    document.querySelector("#inputPageSearch").value=srchquery;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let apiObj;
    if(filter==="All"){
        apiObj={"engine_key":config.SWIFT_TYPE_ENGINE_KEY,"q":srchquery,"page":pagenum};
    }
    else{
        apiObj={"engine_key":config.SWIFT_TYPE_ENGINE_KEY,"q":srchquery,"page":pagenum,"filters":{"page":{"page_type":filter}}};
    }
    axios.post(`https://search-api.swiftype.com/api/v1/public/installs/${config.SWIFT_TYPE_ENGINE_ID}/search.json`,apiObj).then(function (response){
        document.querySelector(".num-of-result-line").innerHTML=`${response.data.info.page.total_result_count} results for "${srchquery}"`;
        if(response.data.record_count>0){
            document.querySelector(".num-of-result-filter").style.display="flex";
            document.querySelector("#selectSearchFilter").value=filter;
            document.querySelector(".num-of-result-line").innerHTML=document.querySelector(".num-of-result-line").innerHTML+` – Page ${response.data.info.page.current_page} of ${response.data.info.page.num_pages}`;
            document.querySelector(".page-nums").innerHTML=`${response.data.info.page.current_page} of ${response.data.info.page.num_pages}`;
            document.querySelector(".srch-tab-lists").innerHTML="";
            document.querySelector(".num-of-result-sub-line").innerHTML="";
            document.querySelector(".no-result-found-box").style.display="none";
            document.querySelector(".search-result-tabs").style.display="block";
            response.data.records.page.forEach(ele => {
                let tabdiv=document.createElement("div");
                let titleP=document.createElement("a");
                let subtitleP=document.createElement("p");
                let descriptionP=document.createElement("p");
                tabdiv.setAttribute("class","srch-tab");
                titleP.setAttribute("class","srch-tab-title");
                subtitleP.setAttribute("class","srch-tab-sub-title");
                descriptionP.setAttribute("class","srch-tab-body");
                titleP.innerText=ele.title;
                titleP.setAttribute("href",ele.url);
                var subtitlePtag = ele.sections===undefined?"":ele.sections[0];
                subtitleP.innerText=ele.page_type===undefined?subtitlePtag:ele.page_type;
                //bodyP.innerText=ele.body.substring(0,200)+"...";
                let bodyDiv = ele.body===undefined?"":ele.body.substring(0,200)+"...";
                descriptionP.innerText=ele.description===undefined?bodyDiv:ele.description;
                tabdiv.appendChild(titleP);
                tabdiv.appendChild(subtitleP===""?"":subtitleP);
                tabdiv.appendChild(descriptionP);
                document.querySelector(".srch-tab-lists").appendChild(tabdiv);
            });
            if(response.data.info.page.current_page===1){
                document.querySelector(".prev-page-arrow").classList.add("page-arrow-disable");
            }
            if(response.data.info.page.current_page===response.data.info.page.num_pages){
                document.querySelector(".next-page-arrow").classList.add("page-arrow-disable");
            }
            if(response.data.info.page.current_page>1){
                document.querySelector(".prev-page-arrow").classList.remove("page-arrow-disable");
            }
            if(response.data.info.page.current_page<response.data.info.page.num_pages){
                document.querySelector(".next-page-arrow").classList.remove("page-arrow-disable");
            }
        }
        else{
            if(filter!="All"){
                document.querySelector(".num-of-result-filter").style.display="flex";
                document.querySelector("#selectSearchFilter").value=filter;
            }
            document.querySelector(".num-of-result-sub-line").innerHTML=`Sorry, no matches were found for “${srchquery}”.`;
            if("spelling_suggestion" in response.data.info.page){
                document.querySelector(".num-of-result-sub-line").innerHTML=document.querySelector(".num-of-result-sub-line").innerHTML+` Search for <span class="search-for-line">${response.data.info.page.spelling_suggestion.text}</span> instead?`;
                document.querySelector(".search-for-line").addEventListener("click",()=>{
                    searchText(document.querySelector(".search-for-line").innerText);
                });
            }
            document.querySelector(".no-result-found-box").style.display="block";
            document.querySelector(".search-result-tabs").style.display="none";
        }
    })
}
// ------------------------------- SWIFTYPE API CALLS ENDS HERE -----------------------



// ---------------------------------- USER TYPING IN NAV SEARCH BAR STARTS HERE --------------------------
export const userTypingInNavSearch=()=>{
    let srchquery=document.querySelector("#inputSearch").value.replace(/[^A-Za-z0-9 ]/g,'').trim();
    if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.");
    }
    cancelToken = axios.CancelToken.source();
    if(srchquery.length>2){
        axios.post(`https://search-api.swiftype.com/api/v1/public/installs/${config.SWIFT_TYPE_ENGINE_ID}/suggest.json`,
        {"engine_key":config.SWIFT_TYPE_ENGINE_KEY,"q":srchquery},{ cancelToken: cancelToken.token }).then(function (response){
            document.querySelector(".search-bar-autocomplete-container").innerHTML="";
            let j=0;
            if(response.data.record_count>0){
                document.querySelector(".search-bar-autocomplete-container").style.display="block";
                document.querySelector(".search-bar .form-group").classList.add("top-rounded");
                response.data.records.page.forEach(res=>{
                    let suggestDiv=document.createElement("div");
                    let titleP=document.createElement("p");
                    let subtitleP=document.createElement("p");
                    titleP.setAttribute("class","autocomplete-title");
                    subtitleP.setAttribute("class","autocomplete-subtitle");
                    suggestDiv.setAttribute("class","nav-autocomplete-suggestions");
                    suggestDiv.setAttribute("id",j++);
                    suggestDiv.addEventListener("click",()=>{
                        window.location=res.url;
                    });
                    titleP.innerHTML=res.highlight.title===undefined?res.title:res.highlight.title;
                    //subtitleP.innerText=res.sections[0]===undefined?"":res.sections[0];                    
                    var subtitlePtag = res.sections===undefined?"":res.sections[0];
                    subtitleP.innerText=res.page_type===undefined?subtitlePtag:res.page_type;
                    suggestDiv.appendChild(titleP);
                    suggestDiv.appendChild(subtitleP);
                    document.querySelector(".search-bar-autocomplete-container").appendChild(suggestDiv);
                });
            }
            else{
                document.querySelector(".search-bar-autocomplete-container").style.display="none";
                document.querySelector(".search-bar .form-group").classList.remove("top-rounded");
            }
        }).catch(err=>{});
    }
    else{
        document.querySelector(".search-bar-autocomplete-container").style.display="none";
        document.querySelector(".search-bar .form-group").classList.remove("top-rounded");
    }
}
// ---------------------------------- USER TYPING IN NAV SEARCH BAR ENDS HERE --------------------------



// ---------------------------------- USER TYPING IN PAGE SEARCH BAR STARTS HERE --------------------------
export const userTypingInPageSearch=()=>{
    let srchquery=document.querySelector("#inputPageSearch").value.replace(/[^A-Za-z0-9 ]/g,'');
    if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel();
    }
    cancelToken = axios.CancelToken.source();
    if(srchquery.length>2){
        axios.post(`https://search-api.swiftype.com/api/v1/public/installs/${config.SWIFT_TYPE_ENGINE_ID}/suggest.json`,
        {"engine_key":config.SWIFT_TYPE_ENGINE_KEY,"q":srchquery},{ cancelToken: cancelToken.token }).then(function (response){
            document.querySelector(".search-page-autocomplete-container").innerHTML="";
            let j=0;
            if(response.data.record_count>0){
                document.querySelector(".search-page-autocomplete-container").style.display="block";
                document.querySelector(".search-page-bar-container .form-group").classList.add("top-rounded");
                response.data.records.page.forEach(res=>{
                    let suggestDiv=document.createElement("div");
                    let titleP=document.createElement("p");
                    let subtitleP=document.createElement("p");
                    titleP.setAttribute("class","autocomplete-title");
                    subtitleP.setAttribute("class","autocomplete-subtitle");
                    suggestDiv.setAttribute("class","page-autocomplete-suggestions");
                    suggestDiv.setAttribute("id",j++);
                    suggestDiv.addEventListener("click",()=>{
                        window.location=res.url;
                    });
                    titleP.innerHTML=res.highlight.title===undefined?res.title:res.highlight.title;
                    //subtitleP.innerText=res.sections[0]===undefined?"":res.sections[0];                    
                    var subtitlePtag = res.sections===undefined?"":res.sections[0];
                    subtitleP.innerText=res.page_type===undefined?subtitlePtag:res.page_type;
                    suggestDiv.appendChild(titleP);
                    suggestDiv.appendChild(subtitleP);
                    document.querySelector(".search-page-autocomplete-container").appendChild(suggestDiv);
                });
            }
            else{
                document.querySelector(".search-page-autocomplete-container").style.display="none";
                document.querySelector(".search-page-bar-container .form-group").classList.remove("top-rounded");
            }
        }).catch(err=>{});
    }
    else{
        document.querySelector(".search-page-autocomplete-container").style.display="none";
        document.querySelector(".search-page-bar-container .form-group").classList.remove("top-rounded");
    }
    // if(srchquery.length<3) srchquery="";

    
}
// ---------------------------------- USER TYPING IN PAGE SEARCH BAR ENDS HERE --------------------------



// --------------------------------- FOCUS OUT OF NAV SEARCH BAR INPUT STARTS HERE --------------------------
export const navSearchFocusOut=()=>{
    setTimeout(() => {
        document.querySelector(".search-bar-autocomplete-container").innerHTML="";
        document.querySelector(".search-bar-autocomplete-container").style.display="none";
        document.querySelector(".search-bar .form-group").classList.remove("top-rounded");
    }, 200);
}
// --------------------------------- FOCUS OUT OF NAV SEARCH BAR INPUT ENDS HERE --------------------------




// --------------------------------- FOCUS OUT OF PAGE SEARCH BAR INPUT STARTS HERE --------------------------
export const pageSearchFocusOut=()=>{
    setTimeout(() => {
        document.querySelector(".search-page-autocomplete-container").innerHTML="";
        document.querySelector(".search-page-autocomplete-container").style.display="none";
        document.querySelector(".search-page-bar-container .form-group").classList.remove("top-rounded");
    }, 200);
}
// --------------------------------- FOCUS OUT OF PAGE SEARCH BAR INPUT ENDS HERE --------------------------



// --------------- ADDING EVENT LISTENER ON ARROW UP DOWN ON NAV SEARCH INPUT STARTS HERE ----------------
export const addingUpDownEnterEventListenerToNavSearch=(event)=>{
    let navSrchOptions=document.querySelectorAll(".nav-autocomplete-suggestions");
    if(event.keyCode===38){
        event.preventDefault();
        if(document.querySelector(".selected")===null){
            document.getElementById(navSrchOptions.length-1).classList.add("selected");
        }
        else if(document.querySelector(".selected").id==="0"){
            document.querySelector(".selected").classList.remove("selected");
        }
        else{
            let currentSelectedId=Number(document.querySelector(".selected").id);
            document.querySelector(".selected").classList.remove("selected");
            document.getElementById((currentSelectedId-1)%navSrchOptions.length).classList.add("selected");
        }
    }
    else if(event.keyCode===40){
        event.preventDefault();
        if(document.querySelector(".selected")===null){
            document.getElementById("0").classList.add("selected");
        }
        else if(document.querySelector(".selected").id==navSrchOptions.length-1){
            document.querySelector(".selected").classList.remove("selected");
        }
        else{
            let currentSelectedId=Number(document.querySelector(".selected").id);
            document.querySelector(".selected").classList.remove("selected");
            document.getElementById((currentSelectedId+1)%navSrchOptions.length).classList.add("selected");
        }
    }
    else if(event.keyCode===13){
        if(document.querySelector(".selected")===null){
            goToSearchPage();
        }
        else{
            document.querySelector(".selected").click();
        }
    }
}
// --------------- ADDING EVENT LISTENER ON ARROW UP DOWN ON NAV SEARCH INPUT ENDS HERE ----------------


// --------------- ADDING EVENT LISTENER ON ARROW UP DOWN ON PAGE SEARCH INPUT STARTS HERE ----------------
export const addingUpDownEnterEventListenerToPageSearch=()=>{
    document.querySelector("#inputPageSearch").addEventListener("keydown",(event)=>{
        let pageSrchOptions=document.querySelectorAll(".page-autocomplete-suggestions");
        if(event.keyCode===38){
            event.preventDefault();
            if(document.querySelector(".selected")===null){
                document.getElementById(pageSrchOptions.length-1).classList.add("selected");
            }
            else if(document.querySelector(".selected").id==="0"){
                document.querySelector(".selected").classList.remove("selected");
            }
            else{
                let currentSelectedId=Number(document.querySelector(".selected").id);
                document.querySelector(".selected").classList.remove("selected");
                document.getElementById((currentSelectedId-1)%pageSrchOptions.length).classList.add("selected");
            }
        }
        else if(event.keyCode===40){
            event.preventDefault();
            if(document.querySelector(".selected")===null){
                document.getElementById("0").classList.add("selected");
            }
            else if(document.querySelector(".selected").id==pageSrchOptions.length-1){
                document.querySelector(".selected").classList.remove("selected");
            }
            else{
                let currentSelectedId=Number(document.querySelector(".selected").id);
                document.querySelector(".selected").classList.remove("selected");
                document.getElementById((currentSelectedId+1)%pageSrchOptions.length).classList.add("selected");
            }
        }
        else if(event.keyCode===13){
            if(document.querySelector(".selected")===null){
                searchText(document.querySelector("#inputPageSearch").value);
            }
            else{
                document.querySelector(".selected").click();
            }
        }
    });
}
// --------------- ADDING EVENT LISTENER ON ARROW UP DOWN ON PAGE SEARCH INPUT ENDS HERE ----------------